export const TRANSLATION_PATHS = {
  ROOT: "i18n/root/",
  AUTH: "i18n/auth/",
  SWAP_REQUEST: "i18n/swap-request/",
  COMING_SOON: "i18n/coming-soon/",
  PROFILE: "i18n/profile/",
  PAYMENT: "i18n/payment/",
  DASHBOARD: "i18n/dashboard/",
  MESSAGES: "i18n/messages/",
};
